const themeContract = {
  tu: {
    textTheme: {
      dark: 'grey-90'
    }
  },
  argos: {
    textTheme: {
      dark: 'grey-90'
    }
  },
  habitat: {
    textTheme: {
      dark: 'brand-1'
    }
  },
  nectar: {
    textTheme: {
      dark: 'brand-2'
    }
  },
  sainsburys: {
    textTheme: {
      dark: 'grey-80'
    }
  }
}

export { themeContract }
